import { render } from "./danger.svg?vue&type=template&id=2212f940"
const script = {}
script.render = render

export default script